/**
 * `/api/dashboard` — the caller's own dashboard layout.
 *
 * A session and no permission; no function here takes a user id. The server
 * stores the cards as sent and knows nothing about them — the card types are
 * declared in this package. See `../pages/dashboard/`.
 */
import type { DashboardCardDto, DashboardLayoutResponse, SaveDashboardLayoutRequest } from '@forsys/shared';
import { apiFetch } from './client';

export function getDashboardLayout(): Promise<DashboardLayoutResponse> {
  return apiFetch<DashboardLayoutResponse>('/dashboard/layout');
}

/** Replaces the whole layout. An empty list puts the dashboard back to its defaults. */
export function saveDashboardLayout(cards: DashboardCardDto[]): Promise<DashboardLayoutResponse> {
  const request: SaveDashboardLayoutRequest = { cards };
  return apiFetch<DashboardLayoutResponse>('/dashboard/layout', { method: 'PUT', json: request });
}
